export default __webpack_public_path__ + "static/media/advt-2.f2eae05e.jpg";